// extracted by mini-css-extract-plugin
module.exports = {"promotionalTilesComponent":"jI","promotionalTile":"jJ","promotionalTileThumb":"jK","promotionalTileHeader":"jL","promotionalTileCaption":"jM"};